export const uspItems2 = [
  {
    Icon: 'check-circle-green',
    Label: 'Alla får sin egen surf',
    SubLabel: 'Spara surfen upp till samma surfmängd som ditt mobilabonnemang.',
  },
  {
    Icon: 'check-circle-green',
    Label: 'Sänk månadskostnaden',
    SubLabel:
      'Priset per person blir lägre när du samlar alla under samma huvudabonnemang.',
  },
  {
    Icon: 'check-circle-green',
    Label: 'Alla kan bli familj',
    SubLabel:
      'Bilda din egna Halebop familj. Vänner, sambos, familj och allt där emellan kan skaffa familjeabonnemang. ',
  },
];
